import { get } from "./api_helper";
import * as url from "./url_helper";

// currently logged in user
export const getCurrentUser = () => get(url.GET_CURRENT_USER);

// currently all customers
export const getCustomers = () => get(url.GET_CUSTOMERS);
